module.exports = __webpack_public_path__ + "img/banner-call-center.c21fafb3.png";